import { Skeleton } from '@/components/ui/skeleton';

const DEFAULT_SKELETON_COUNT = 5;

const RuleTileSkeleton = () => (
  <div className="flex items-center">
    <Skeleton className="mr-2 size-4 rounded" />
    <div className="relative flex w-[576px] items-center gap-4 rounded-lg border border-stroke bg-background px-4 py-4">
      <Skeleton className="size-11 shrink-0 rounded" />
      <div className="flex flex-1 flex-col gap-1">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton className="absolute top-4 right-4 size-8 rounded" />
    </div>
  </div>
);

interface RulesSkeletonProps {
  count?: number;
}

export const RulesSkeleton = ({ count = DEFAULT_SKELETON_COUNT }: RulesSkeletonProps) => (
  <div className="flex flex-col items-center gap-3 self-stretch">
    {Array.from({ length: count }, (_, index) => (
      <RuleTileSkeleton key={`rule-skeleton-${index}`} />
    ))}
  </div>
);
